// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 583 ? "edf7e618" : chunkId) + "." + {"583":"c90a21326542c7f1","633":"f87e5e628b404b16"}[chunkId] + ".js";
};